import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";

export interface OperationNormaliseQuantityRequestModel {
	readonly normalisedQuantity: number;
}

export interface OperationNormaliseQuantityRequestProperties {
	readonly requestModel: OperationNormaliseQuantityRequestModel;
	readonly collectionId: string;
}

export const useOperationNormaliseQuantity = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse, OperationNormaliseQuantityRequestProperties> = (requestProperties: OperationNormaliseQuantityRequestProperties) => {
		return http<undefined, OperationNormaliseQuantityRequestModel>({
			method: "POST",
			url: "/collection/" + requestProperties.collectionId + "/operation/normalise-quantity",
			body: requestProperties.requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: (_, requestProperties) => {
			queryClient.invalidateQueries({ queryKey: ["collections"] });
			queryClient.invalidateQueries({ queryKey: ["collectionsPerformanceDelta"] });
			queryClient.invalidateQueries({ queryKey: ["collection", requestProperties.collectionId] });
			queryClient.invalidateQueries({ queryKey: ["collectionVariantDetails", requestProperties.collectionId] });
			queryClient.invalidateQueries({ queryKey: ["dashboardCurrentPosition"] });
			queryClient.invalidateQueries({ queryKey: ["dashboardHistoricalPositions"] });
			queryClient.invalidateQueries({ queryKey: ["dashboardPerformanceDeltas"] });
			queryClient.invalidateQueries({ queryKey: ["transactionSummaries"] });
			queryClient.invalidateQueries({ queryKey: ["transactions", requestProperties.collectionId] });
		}
	});
};